import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import ar from './ar'
import ku from './ku'
import tr from './tr'

Vue.use(VueI18n)

export const RTL_LOCALES = ['ar', 'ku']

// Theme + Vuetify CSS that ships LTR-only (no [dir=rtl] rules of their own) and has an
// rtlcss-generated mirror under assets/rtl/css/ with the same filename.
const RTL_THEME_STYLESHEETS = ['vuetify', 'bootstrap', 'core', 'components', 'colors', 'app_styles', 'print_style']

const savedLocale = localStorage.getItem('app_locale') || 'en'
const isRtl = RTL_LOCALES.includes(savedLocale)

document.documentElement.setAttribute('lang', savedLocale)
document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr')

if (isRtl) {
  RTL_THEME_STYLESHEETS.forEach(name => {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.href = `/assets/rtl/css/${name}.css`
    // Appended after index.html's LTR <link> tags (already parsed by the time this
    // module runs), so equal-specificity mirrored rules win the cascade.
    document.head.appendChild(link)
  })
}

export default new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: { en, ar, ku, tr }
})



// WEBPACK FOOTER //
// ./src/lang/index.js